/*
 * Component for title of pages in tabs
 */
import React, { Component } from 'react';
import { Grid, Tooltip, Typography } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';

class TabPageTitle extends Component {
    render() {
        let tooltipText = this.props.tooltipText;

        return (
            <Grid container spacing={0} direction="column" justifyContent="flex-start">
                <Grid item xs={12}>
                    <Typography variant="h6" >{this.props.title}</Typography>
                </Grid>
                <Grid item xs={12}>
                    {tooltipText != null && tooltipText !== '' &&
                    <Typography variant="body2">
                        {this.props.subtitle}
                        <Tooltip placement='bottom' title={tooltipText}>
                            <HelpOutline fontSize="small" style={{marginLeft: "4px", verticalAlign: "-14%"}}/>
                        </Tooltip>
                    </Typography>}
                    {(tooltipText == null || tooltipText === '') &&
                    <Typography variant="body2">
                        {this.props.subtitle}
                    </Typography>}
                </Grid>
            </Grid>
        );
    }
}

export default TabPageTitle;
